import { render, staticRenderFns } from "./submitErrorModal.vue?vue&type=template&id=e5b640d0&scoped=true"
import script from "./submitErrorModal.vue?vue&type=script&lang=js"
export * from "./submitErrorModal.vue?vue&type=script&lang=js"
import style0 from "./submitErrorModal.vue?vue&type=style&index=0&id=e5b640d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b640d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5b640d0')) {
      api.createRecord('e5b640d0', component.options)
    } else {
      api.reload('e5b640d0', component.options)
    }
    module.hot.accept("./submitErrorModal.vue?vue&type=template&id=e5b640d0&scoped=true", function () {
      api.rerender('e5b640d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/submitErrorModal.vue"
export default component.exports